document.addEventListener("DOMContentLoaded", function () {
  const lensAndFrameOrigin = "https://lensandframe.co";
  const fallbackLensAndFrameUrl = `${lensAndFrameOrigin}/pages/ombraz-rx`;
  const lensAndCoUrlParams = new URLSearchParams(window.location.search);

  function getReferrerVariantId() {
    if (!document.referrer) return "";

    try {
      return new URL(document.referrer).searchParams.get("variant") || "";
    } catch (_error) {
      return "";
    }
  }

  function getSafeRedirectUrl() {
    const rawLensAndCoUrl = lensAndCoUrlParams.get("lensandco");
    const variantId =
      lensAndCoUrlParams.get("variant") || getReferrerVariantId();
    let redirectUrl;

    try {
      redirectUrl = rawLensAndCoUrl
        ? new URL(rawLensAndCoUrl)
        : new URL(fallbackLensAndFrameUrl);
    } catch (_error) {
      redirectUrl = new URL(fallbackLensAndFrameUrl);
    }

    if (redirectUrl.origin !== lensAndFrameOrigin) {
      redirectUrl = new URL(fallbackLensAndFrameUrl);
    }

    if (variantId) {
      redirectUrl.searchParams.set("variant", variantId);
    }

    return redirectUrl.toString();
  }

  const delayBetweenSteps = 1300;
  const progressBar = document.querySelector(".ombraz__rx-progress-bar");
  const steps = document.querySelectorAll(".ombraz__rx-progress-step");
  const numSteps = steps.length;
  let currentStepIndex = 0;
  let progress = 0;

  const redirectUrl = getSafeRedirectUrl();

  if (!progressBar || numSteps === 0) {
    window.location.href = redirectUrl;
    return;
  }

  const stepWidth = 100 / numSteps;

  // Initialize progress bar width
  progressBar.style.width = stepWidth + "%";

  // Function to update progress bar width
  function updateProgress() {
    progress += stepWidth;
    progressBar.style.width = progress + "%";

    Array.from(steps).forEach((step, index) => {
      if (index === currentStepIndex) {
        step.classList.add("active");
      }
    });
  }

  // Function to show the next step
  function showNextStep() {
    // Update progress bar
    updateProgress();

    // Increment the step index or reset it if it exceeds the number of steps
    currentStepIndex = (currentStepIndex + 1) % numSteps;

    // Check if all steps have been shown
    if (currentStepIndex === 0) {
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, delayBetweenSteps);
      return;
    }

    // Show the next step after a delay
    setTimeout(showNextStep, delayBetweenSteps);
  }

  // Start showing the next steps
  setTimeout(showNextStep, delayBetweenSteps);
});
